<header class="mc-app-header">
  <img class="mc-app-header-image" alt="" src="assets/images/header.png">
  <img class="mc-app-header-status-logo" alt="Flare Online Status" src="assets/images/status-logo.svg">
  <img class="mc-app-header-logo" alt="Flare Online Status" src="assets/images/status-incident/logo.svg">
</header>
